import { defineStore } from "pinia";
import { useForm } from "@/form";

export const useStore = defineStore("domain", {
    state: () => {
        return {
            domainData: undefined,
        };
    },

    getters: {
        domain: (state) => {
            return state.domainData;
        },
        user: (state) => {
            return state.domainData?.user;
        },
        subscription: (state) => {
            return state.domainData?.user?.subscription;
        },
    },

    actions: {
        setDomain(data) {
            this.domainData = data;
        },

        async fetchDomain() {
            try {
                const response = await useForm().post("auth_domain");
                this.domainData = response;
            } catch (error) {
                return error;
            }
        },

        async refresh() {
            await this.fetchDomain();
        },
    },
});
